/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Showroom
 *
 * 1 = InPreparation
 *
 * 2 = DueIn
 *
 * 3 = NoCategory
 */
export enum StockStateDivisionTypeEnum {
  Showroom = 0,
  InPreparation = 1,
  DueIn = 2,
  NoCategory = 3,
}
